export default __webpack_public_path__ + "static/media/juice-headline-mobile@3x.9b454e1d.png";